export default (basePath, id) => `${basePath}/${encodeURIComponent(id)}`;



// WEBPACK FOOTER //
// ./src/components/button/linkToRecord.js